import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './main.routes';

export class MainController {
    $http;

    awesomeThings = [];
    newThing = '';

    /*@ngInject*/
    constructor($http, $state, $location, $stateParams, searchService, $anchorScroll, $scope, $rootScope) {
        this.$http = $http;
        this.$state = $state;
        this.$location = $location;
        this.$stateParams = $stateParams;
        this.searchService = searchService;
        this.$anchorScroll = $anchorScroll;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        
        this.$rootScope.canonicalUrl = this.$location.$$protocol + '://' + this.$location.$$host + this.$location.$$path;
        

    }


    $onInit() {
        console.log();
        this.$scope.baseURL = this.searchService.getBaseURL();
        var key;
        //Check if key exists in service and update URL params
        if (this.searchService.getKey()) {
            key = this.searchService.getKey();
            console.log(key);
            this.$location.search('key', key);
        }
        // Check if key exists in URL params and set it in service
        if (this.$location.search().key) {
            key = this.$location.search().key;
            console.log(key);
            this.searchService.setKey(key);
        }
        //Check key for nav access
        this.$http.get(`${this.$scope.baseURL}/api/cw/client/` + key)
            .then(response => {
                this.$scope.client = response.data[0];
                console.log(this.client);
            });

        // Get recipes tags
        this.$http.get(`${this.$scope.baseURL}/api/tags/Recipes`)
            .then(response => {
                console.log(response);
                this.recipeTags = response.data;
            })
            .catch(err => {
                console.log(err);
            });

        //Get articles tags
        this.$http.get(`${this.$scope.baseURL}/api/tags/Articles`)
            .then(response => {
                console.log(response);
                this.articleTags = response.data;
            })
            .catch(err => {
                console.log(err);
            })

        //Get initiative tags
        this.$http.get(`${this.$scope.baseURL}/api/tags/Initiatives`)
            .then(response => {
                console.log(response);
                this.initiativeTags = response.data;
            })
            .catch(err => {
                console.log(err);
            })

        //Get categories
        this.$http.get(`${this.$scope.baseURL}/api/categories`)
            .then(response => {
                console.log(response);
                this.collectionCategories = response.data;
                this.articleCategories = _.orderBy(_.filter(this.collectionCategories, { 'collection': 'Articles' }), 'rank');
                this.initiativeCategories = _.orderBy(_.filter(this.collectionCategories, { 'collection': 'Initiatives' }), 'rank');;
                this.recipeCategories = _.orderBy(_.filter(this.collectionCategories, { 'collection': 'Recipes' }), 'rank');;

            })
            .catch(err => {
                console.log(err);
            })




    }

    loadResults(category) {
        var params;
        console.log(this.searchParams);
        if (category) {
            params = {
                'category': category
            };
        } else if (this.searchParams && this.searchParams.uuid) {
            params = {
                'q': this.searchParams.uuid
            };
        } else if (this.searchParams && !this.searchParams.uuid) {
            console.log(this.searchParams);
            params = {
                'q': this.searchParams
            };
        }

        this.searchService.setSearchParams(params);
        this.$stateParams = params;
        this.$state.go('articles', params);
    }

    loadInitiatives(category) {
        var params;
        console.log(this.searchParamsInitiatives);
        // Clear Subcategories 
        this.searchService.setSubCategory(null);
        if (category) {
            params = {
                'category': category
            };
        } else if (this.searchParamsInitiatives && this.searchParamsInitiatives.tag) {
            params = {
                'q': this.searchParamsInitiatives.uuid
            };
        } else if (this.searchParamsInitiatives && !this.searchParamsInitiatives.tag) {
            params = {
                'q': this.searchParamsInitiatives
            };
        }

        this.searchService.setSearchParams(params);
        this.$stateParams = params;
        this.$state.go('initiatives', params);
    }

    loadRecipes(category) {
        var params;
        console.log(this.searchParamsRecipes);

        if (category) {
            params = {
                'category': category
            };
        } else if (this.searchParamsRecipes && this.searchParamsRecipes.uuid) {
            params = {
                'q': this.searchParamsRecipes.uuid
            };
        } else if (this.searchParamsRecipes && !this.searchParamsRecipes.uuid) {
            params = {
                'q': this.searchParamsRecipes
            };
        }

        this.searchService.setSearchParams(params);
        this.$stateParams = params;
        this.$state.go('recipes', params);
    }

    updateLocation(anchor) {
        console.log(anchor);
        this.$anchorScroll(anchor);
        this.$location.hash(anchor);
    }
}

export default angular.module('connectwellApp.main', [uiRouter])
    .config(routing)
    .component('main', {
        template: require('./main.html'),
        controller: MainController
    })
    .name;


// WEBPACK FOOTER //
// ./client/app/main/main.component.js